import React from 'react';
import PropTypes from 'prop-types';
import { FormFieldContext, FormSelect } from '@metarouter-private/mr-mui';

import useConsentCategories from './useConsentCategories';

const HELPER_TEXT = 'We recommend that you consult with your legal team when determining your consent requirements.';
const LABEL = 'Consent Category';
const DISABLED_LABEL = 'Consent Category - Not Applicable';
const REQUIRED_MESSAGE = 'Required field';

export default function ConsentCategorySelect({ name, defaultValue, required, disabled }) {
  const consentCategories = useConsentCategories();

  // manually override the required validator, mr-mui + RHF bug when toggling from required -> not required
  // @see https://app.shortcut.com/metarouter/story/38908/mr-mui-rhf-changing-an-input-required-not-required-still-keeps-it-required
  const rules = { required: required ? REQUIRED_MESSAGE : false };

  return (
    <FormFieldContext
      name={name}
      label={disabled ? DISABLED_LABEL : LABEL}
      required={required}
      helperText={HELPER_TEXT}
      defaultValue={defaultValue}
      disabled={disabled}
      rules={rules}
    >
      <FormSelect options={consentCategories} variant="outlined" size="small" data-test-id="consentCategoriesSelect" />
    </FormFieldContext>
  );
}

ConsentCategorySelect.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

ConsentCategorySelect.defaultProps = {
  defaultValue: '',
  required: true,
  disabled: false,
};
